import { observer } from "mobx-react-lite";
import React, { useState, FormEvent, useContext, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Segment, Form, Button } from "semantic-ui-react";
import { ICustomer } from "../../../app/models/customer";
import CustomerStore from "../../../app/stores/customerStore";

interface DetailParams {
  id: string;
}

const CustomerEditForm: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history,
}) => {
  const customerStore = useContext(CustomerStore);
  const { editCustomer, submitting, loadCustomer, clearCustomer } =
    customerStore;

  const [customer, setCustomer] = useState<ICustomer>({
    id: "",
    createdAt: "",
    updatedAt: "",
    name: "",
    abn: "",
    address: "",
    contactName: "",
    email: "",
    phone: "",
    remark: "",
  });

  useEffect(() => {
    loadCustomer(match.params.id).then((customer) => {
      setCustomer(customer);
    });

    return () => {
      clearCustomer();
    };
  }, [loadCustomer]);

  const handleSubmit = () => {
    editCustomer(customer).then(() =>
      history.push(`/dailymanagement/customer`)
    );
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setCustomer({ ...customer, [name]: value });
  };

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form widths="equal">
          <Form.Input
            label="Name"
            name="name"
            placeholder="Name"
            value={customer.name}
          />
          <Form.Input
            label="ABN"
            name="abn"
            placeholder="ABN"
            value={customer.abn}
          />
          <Form.Input
            label="Address"
            name="address"
            placeholder="Address"
            value={customer.address}
          />
          <Form.Input
            label="Contact Name"
            name="contactName"
            placeholder="Contact Name"
            value={customer.contactName}
          />
          <Form.Input
            label="Email"
            required
            name="email"
            placeholder="Email"
            value={customer.email}
          />
          <Form.Input
            label="Phone"
            name="phone"
            placeholder="Phone"
            value={customer.phone}
          />
          <Form.Input
            label="Remark"
            name="remark"
            placeholder="Remark"
            value={customer.remark}
          />
        </Form>
        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        />
        <Button
          onClick={() => history.push("/dailymanagement/customer")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(CustomerEditForm);
